import React from "react"
import Pic from "./image"

const Partners = () => (
  <div className="parnters container mx-auto p-4 lg:p-10 lg:py-24">
    <div
      className="partner-logo"
      data-sal="slide-up"
      data-sal-delay="300"
      data-sal-easing="ease"
    >
      {/* <Pic filename="partners/partner-canada.png" /> */}{" "}
      <Pic filename="partners/partner-anta.png" />
      <Pic filename="partners/partner-toyota.png" />
      <Pic filename="partners/partner-mackenzie.png" />
    </div>{" "}
  </div>
)

export default Partners
